import React, { useState } from 'react';
import { Tabs } from 'antd';
import List1 from '../components/List1';
import List2 from '../components/List2';
import { getQueryVariable } from '@/utils/utils';
import './index.less';

const { TabPane } = Tabs;

const Mbtf: React.FC<{}> = () => {
  const defaultActiveKey = getQueryVariable('activeTab') || 'ue';
  return (
    <div className="mbtf-list-wrap">
      <div className="page-content">
        <Tabs defaultActiveKey={defaultActiveKey}>
          <div className="gapBox"></div>
          <TabPane tab="UE" key="ue">
            <List1 />
          </TabPane>
          <TabPane tab="元设计（正向）" key="gmodeler">
            <List2 />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default Mbtf;
